import React, { FC, useMemo } from 'react';
import { ThemeProvider as _ThemeProvider } from 'styled-components';
import { defaultTheme } from './defaultTheme';
import { ThemeProviderProps } from './models';

export const ThemeProvider: FC<ThemeProviderProps> = ({ children, extendTheme }) => {
  const theme = useMemo(() => ({ ...defaultTheme, ...extendTheme }), [extendTheme]);

  return <_ThemeProvider {...{ theme }}>{children}</_ThemeProvider>;
};
